<template>
  <div
    v-if="wordings && statusInfo"
    class="status-points-cards"
  >
    <StatusCard
      :status-label="wordings.status"
      :status="statusInfo.statut"
      :end-date="statusInfo.endDate"
      :end-date-label="wordings.expiration"
      :lang="lang"
    />
    <PointsCard
      :wordings="wordings"
      :reward-points="statusInfo.points"
      :status-points="statusInfo.statusPoints"
      :nights="statusInfo.nights"
      :lang="lang"
    />
  </div>
</template>
<script lang="es" src="./StatusPointsCard.es"></script>
<style lang="scss" src='./StatusPointsCard.scss' scoped></style>
